import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { RaiseNowIframeEPPComponent } from './components/raisenow-iframe/raisenow-iframe-epp.component';
import { RaiseNowIframeTamaroComponent } from './components/raisenow-iframe/raisenow-iframe-tamaro.component';
import { RaiseNowModalComponent } from './components/raisenow-modal/raisenow-modal.component';

@NgModule({
  declarations: [RaiseNowIframeEPPComponent, RaiseNowModalComponent],
  imports: [RaiseNowIframeTamaroComponent, SharedModule],
  exports: [RaiseNowModalComponent],
})
export class RaisenowModule {}
